var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCentralAfricanRepublic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 513,
    viewBox: "0 0 512 513",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512.989C397.385 512.989 512 398.374 512 256.989C512 115.604 397.385 0.989258 256 0.989258C114.615 0.989258 0 115.604 0 256.989C0 398.374 114.615 512.989 256 512.989Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.873 134.554C447.793 73.9252 390.91 28.1562 322.783 9.79419L311.653 134.554H480.873Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.127 134.554H200.347L189.217 9.79419C121.09 28.1562 64.208 73.9262 31.127 134.554V134.554Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.652 256.989V379.424H480.872C500.717 343.053 512 301.339 512 256.989H311.652Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.348 256.989H0C0 301.339 11.283 343.053 31.127 379.424H200.347V256.989H200.348Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.127 379.424C64.208 440.053 121.09 485.822 189.217 504.184L200.347 395.075L31.127 379.424Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.783 504.184C390.91 485.822 447.793 440.053 480.873 379.424L311.653 395.073L322.783 504.184Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.652 395.073L480.873 379.424H311.652V395.073Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.348 379.424H31.127L200.348 395.073V379.424Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 0.989258C232.893 0.989258 210.511 4.06926 189.217 9.80826V504.171C210.511 509.909 232.893 512.989 256 512.989C279.107 512.989 301.489 509.909 322.783 504.17V9.80826C301.489 4.06926 279.107 0.989258 256 0.989258V0.989258Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.698 56.6414L144.604 77.8984H166.957L148.875 91.0364L155.782 112.293L137.698 99.1564L119.615 112.293L126.524 91.0364L108.442 77.8984H130.793L137.698 56.6414Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(0 0.989258)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentralAfricanRepublic);
export default __webpack_public_path__ + "static/media/centralAfricanRepublic.01783e1385fa4b7d6e2c39059e9f661c.svg";
export { ForwardRef as ReactComponent };